<template>
    <div class="row justify-content-md-center">
        <div class="col-12 col-lg-6">
            <div class="py-5">
                <div class="pb-4">
                    <image-voucher></image-voucher>
                    <h4 class="h3"><span class="text-capitalize">{{ data.customerFirstName }}</span>, {{ __("messages.bags") }}
                    </h4>
                    <p>{{ __("messages.email_reservation_voucher") }} <strong>{{ data.customerEmail }}</strong></p>
                    <div class="info">
                        <h5>{{ __("messages.reservacion_id") }} {{ data.bookingId }}</h5>
                        <p>{{ __("messages.reservation_message") }} {{ __("messages.site_name", [siteConfig.appName]) }}</p>
                        <a class="btnPrimary"
                            :href="__('url.url_go_itinerary_'+ siteConfig.siteName) + '?MasterLocatorId=' + data.bookingId + '&email=' + data.customerEmail"
                            target="_blank" role="button">{{ __("messages.review_itinerary") }} <span
                                class="icons-chevron-right"></span></a>
                    </div>
                    <div v-if="rapd" class="h4 paymentInstructions__section mt-3"
                        v-html="__('messages.booked_with_rapd_benefit')">
                    </div>

                </div>
                <voucher-rapd-instructions v-if="siteConfig.code !== 'TB' && rapd"></voucher-rapd-instructions>
                <hr v-if="rapd">
                <!--Resumen de reservacion-->
                <h5>{{ data.hotelInformation.serviceCarrierName }}</h5>
                <i class="font-icons" :class="getStarClass()"></i>
                <p>{{ hotel.location.street }}, {{ hotel.location.city }}, {{ hotel.location.state }}, {{
                    hotel.location.country }}
                </p>
                <div class="summary-block-content">
                    <div class="mb-3 d-flex g-8">
                        <i class="icons-calendar-today font-24 font-subtle"></i>
                        
                        <div class="summary-data-info">
                            <span class="summary-data-label">{{ __("messages.date_checkin_checkout") }}</span>
                            <span class="summary-data-copy">{{ data.hotelInformation.startDate | date("LL") }}
                                <template
                                    v-if="data.hotelInformation.startHour && data.hotelInformation.startHour.length">
                                    {{ data.hotelInformation.startHour }} hrs.
                                </template>
                                - {{ data.hotelInformation.endDate | date("LL") }}
                                <template v-if="data.hotelInformation.endHour && data.hotelInformation.endHour.length">
                                    {{ data.hotelInformation.endHour }} hrs.
                                </template>
                            </span>
                        </div>
                    </div>
                    <div class="mb-3 d-flex g-8">
                        <i class="icons-guests font-24 font-subtle"></i>
                        
                        <div class="summary-data-info">
                            <span class="summary-data-label">{{ __("messages.paxes") }}</span>
                            <span class="summary-data-copy">{{ adults }} {{ __("messages.adults")
                                }},
                                {{ data.hotelInformation.roomsCount }} {{ __("messages.room") }}</span>
                        </div>
                    </div>
                    <div class="mb-3 d-flex g-8 d-flex">
                        <i class="icons-hotel font-24 font-subtle"></i>
                        
                        <div>
                            <div class="summary-data-info">
                                <span class="summary-data-label">{{ __("messages.room_type") }}</span>
                                <div v-for="group in groupedRoomsArray" :key="group.description + group.mealPlanCode"
                                    class="d-flex">
                                    <div>
                                        <div class="mr-2">{{ group.count }}x</div>
                                    </div>
                                    <div>

                                        <span class="summary-data-copy">{{ group.description }}</span>
                                        <span class="summary-data-copy"><i class="icons-font icons-local-dining"></i>
                                            {{ __("messages.mealplan") }}: {{ __('mealplans.' + group.mealPlanCode) }}
                                        </span>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="content-info" v-if="collectType == 2">
                    <h3 class="title"> {{ __("messages.pay_hotel_collect") }} </h3>
                    <h3><currency-display :amount="(data.hotelInformation.serviceAmountTotal * data.hotelInformation.roomsCount) + this.amauntFeees" :showCurrencyCode="true" :applyDecimals="true"></currency-display></h3>
                    <p v-if="!( getExchange.currency == currencyHC && (amauntTotal + this.amauntFeeesOriginal) == ((data.hotelInformation.serviceAmountTotal * data.hotelInformation.roomsCount) + this.amauntFeees))">
                        {{ getExchange.currency != currencyHC ? __('messages.messagge-fee', [getExchange.currency]) : __('messages.messagge-fee', [' ']) }}
                        <strong><currency-display :amount=" amauntTotal + this.amauntFeeesOriginal" :showCurrencyCode="true" :applyDecimals="true" :currencyCode="currencyHC" :applyConvertion="false" :applySymbol="true"></currency-display></strong>
                        {{ __('messages.messagge-fee-2') }}
                    </p>
                </div>
                <hr v-if="data && data.payments && data.payments.length && collectType != 2">
                <!--Resumen de Pago-->

                <div v-if="collectType !== 2">
                    <div class="summary-block-content" v-for="(payment, index) in data.payments" :key="index">
                        <div class="mb-3 d-flex g-8">
                            <i class="icons-money-sign font-24 font-subtle"></i>
                            
                            <div>
                                <span class="summary-data-label d-block">{{ rapd ? __("messages.payment_pending") : __("messages.payment_total") }}</span>
                                <span class="summary-data-copy"> <currency-display :amount="payment.paymentAmount" :showCurrencyCode="true" :applyDecimals="true"></currency-display></span>
                            </div>
                        </div>
                    </div>
                </div>
                <hr v-if="show">

                <div v-if="show" class="banner-txt">
                    <small>{{ __("messages.cancellation_polcy") }}</small>
                    <p class="h6 text-success">{{ __("messages.free_cancellation") }}</p>
                    <p>{{ __('messages.reservation_until_h_c') }} {{ cancellation.cancellationPolicies.untilDateCancellation |
                        date(__('formaters.cancellation')) }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CancellationModal from '../modals/CancellationModal'
import ImageVoucher from './ImageVoucher';
import { AlgoliaServices } from '../../services/AlgoliaService';
import VoucherRapdInstructions from './VoucherRapdInstructions';
import { storeToRefs } from 'pinia';
import { useExchangeRateStore } from "../../stores/exchange";
const site = window.__pt.settings.site;
const culture = window.__pt.cultureData;

export default {
    props: ['data', 'hotel', 'rapd', 'infoHotelPayment'],
    setup() {
            const exchangeStore = useExchangeRateStore();
            const { getExchange } = storeToRefs(exchangeStore);

            return { getExchange };
        },
    data() {
        return {
            culture,
            type: {},
            modalCancellation: 0,
            cancellation: {},
            siteConfig: site,
            amauntTotal: 0,
            amauntFeees: 0,
            amauntFeeesOriginal: 0,
            currencyHC: '',
            currencySite: culture.currencySymbol.replace(/[\$\s]/g, ''),
            currencySymbol : culture.currency,
            appName: site.appName,
            collectType: 0,
            groupedRoomsArray: [],
            adults: 0,
            kids: 0,
            show: false
        };
    },
    async mounted() {
        this.getEventAlgolia();
        this.getTotalsAmounts();
        this.adults = 0;
        this.kids = 0;
        this.cancellation = this.data.roomList.find(item => item.cancellationPolicies.isCancellationFree);
        this.show = !!this.cancellation; 

        const groupedRooms = this.data.roomList.reduce((acc, room) => {
            const key = `${room.serviceCarrierDescription}-${room.mealPlanCode}`; 
            if (!acc[key]) {
                acc[key] = {
                    description: room.serviceCarrierDescription,
                    mealPlanCode: room.mealPlanCode,
                    count: 0,
                };
            }
            acc[key].count += 1;
            this.adults +=  room.adults;
            this.kids +=  room.kids;
            return acc;
        }, {});

        this.groupedRoomsArray = Object.values(groupedRooms);
    },
    methods: {
        getStarClass() {
            return [`icon-${this.hotel.stars}-star`];
        },
        openaModalCancellation() {
            this.modalCancellation = +1;
            $("#modal-cancellation").modal("show");
        },
        getEventAlgolia() {
            AlgoliaServices.getEventAlgolia("Order", "purchase");
        },
        getTotalsAmounts() {
            this.amauntTotal = 0;
            if (this.infoHotelPayment && this.infoHotelPayment.travelItinerary && this.infoHotelPayment.travelItinerary.bookingServices) {
                this.infoHotelPayment.travelItinerary.bookingServices.forEach((service) => { // Cambio a función de flecha
                    this.collectType = service.collectType;
                    if (service.rate) {
                        this.amauntTotal += service.rate.collectAmount;
                        if (!this.collectCurrency && service.rate.collectCurrency) {
                            this.currencyHC = service.rate.collectCurrency;
                        }
                    }
                    this.amauntFeees += service.serviceFees.reduce((accum, item) => accum + item.clientAmount, 0);
                    this.amauntFeeesOriginal += service.serviceFees.reduce((accum, item) => accum + item.amount, 0);
                });
            }
        }
    },
    components: {
        ImageVoucher,
        CancellationModal,
        VoucherRapdInstructions
    }
}
</script>
